enum RoutesEnum {
  HOME = "/",
  DATABASES = "/db", // New route for databases
  SEARCH = "/search", // New route for the search page
}
export default RoutesEnum;
